import { render, staticRenderFns } from "./QuotationNotes.vue?vue&type=template&id=44007247"
import script from "./QuotationNotes.vue?vue&type=script&lang=js"
export * from "./QuotationNotes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports